import SelectField from '@pelckmans/elementis/components/select-field';
import { useTranslation } from 'react-i18next';
import { useResultsDataContext } from '../../../context/ResultsDataContext';
import { useFilters } from '../../../context/filter-context/FilterContext';

export default function SchoolYearFilter() {
  const { t } = useTranslation();
  const { schoolYears } = useResultsDataContext();
  const { selectedSchoolYear, setSelectedSchoolYear, selectedModule } = useFilters();
  const { scorableItems } = useResultsDataContext();

  return (
    <SelectField
      value={selectedSchoolYear || null}
      onChange={setSelectedSchoolYear}
      required
      size="sm"
      aria-label={t('PAGES.RESULTS.FILTERS.SCHOOL_YEAR_FILTER.A11Y_LABEL')}
      renderValueContent={year => year.title}
      dropdownMenuProps={{
        ariaLabel: t('PAGES.RESULTS.FILTERS.SCHOOL_YEAR_FILTER.DROPDOWN_MENU.A11Y_LABEL'),
      }}
      disabled={scorableItems.filter(x => x.module === selectedModule?.id).length === 0}
    >
      {Object.values(schoolYears || {}).map(year => (
        <SelectField.Item key={year.id} text={year.title} value={year} />
      ))}
    </SelectField>
  );
}
